import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {seoOfContentSelector} from "../../ducks/content";
import Grid from "@material-ui/core/Grid";
import Tabs from "../../../common/Tabs";

import styles from "./seo-texts.module.scss";

function SeoTexts(props) {
  const {
    seo: {beforeFooterText, tabsBlock}
  } = props;
  function createMarkup(html) {
    return {__html: html};
  }
  return (
    <Grid container>
      <Grid item lg={3} xs={12}></Grid>
      <Grid item lg={9} xs={12}>
        {tabsBlock && tabsBlock.length ? (
          <div className={styles.tabsBlock}>
            <Tabs tabs={tabsBlock} />
          </div>
        ) : null}
        {beforeFooterText ? (
          <div
            className={styles.beforeFooterText}
            dangerouslySetInnerHTML={createMarkup(beforeFooterText)}
          />
        ) : null}
      </Grid>
    </Grid>
  );
}

SeoTexts.propTypes = {
  seo: PropTypes.object
};

export default connect((state) => ({
  seo: seoOfContentSelector(state)
}))(SeoTexts);
